// extracted by mini-css-extract-plugin
export default {"fixed":"pageView_fixed__PB5x6","page":"pageView_page__J2I2H"};